export const detail = {
        routeTitle: 'Liste der Benutzer zum geladenen Standort',
        listOfUsers: 'Liste der Benutzer',
        homeDetail: 'Detail',
        metersLabel: 'Messgeräte',
        usersLabel: 'Benutzer am Standort',
        siteConfig: 'Standort-Konfiguration',
        noUsersLabel: 'Keine Benutzer im ausgewählten Standort',
        detailRouteTitle: 'Standort Detail',
        detailRoute: 'Detail',
        detailInformationTitle: 'Standort Information',
        deleteConfirmTitle: 'Sind sie sicher, dass sie diesen Standort löschen wollen?',
        deleteConfirmDescription: ['Der Standort mit dem Namen', 'wird permanent gelöscht.'],
        // Meters
        addMeterButton: 'Messgerät anlegen',
        addMeterModalTitle: 'Neues Messgrät anlegen',
        addDeviceModalTitle: 'Neuen Verbraucher zum aktiellen Messgerät anlegen',
        addDeviceButton: 'Verbraucher anlegen',
        canNotFetchDevicesForDeletedMeter:
            'Es ist nicht möglich die Verbraucher zu einem gelöschten Messgerät einzulesen.',
        deleteDeviceModalTitle:
            'Sind sie sicher, dass sie den Verbraucher zum aktuellen Messgerät löschen wollen?',
        deleteDeviceConfirmDescription: [
            'Der Verbraucher zum aktuellen Messgerät mit dem Namen',
            'wird nach dieser Aktion gelöscht.'
        ],
        undeleteDeviceOrMeter: 'wird nach dieser Aktion wieder hergestellt.',
        deleteMeterModalTitle: 'Sind sie sicher, dass sie dieses Messgerät löschen wollen?',
        deleteMeterConfirmDescription: ['Das Messgrät mit dem Namen', 'wird durch diese Aktion gelöscht.'],
        editMeterModalTitle: 'Messgerät bearbeiten',
        editDeviceModalTitle: 'Verbraucher zum aktuellen Messgerät bearbeiten',
        editDeviceButton: 'Messgerät bearbeiten',
        meterName: 'Name des Messgeräts',
        meterMacAddress: 'Mac Adresse',
        capacity: 'Kapazität (kWp / kWh)',
        installationDate: 'Datum der Installation',
        meterMacAddressFormatField:
            'Format der Mac Adresse ist ungültig. Allowed characters are a-f A-F and 0-9. Allowed length is 12 characters.',
        meterIpAddress: 'IP Adresse',
        meterUrl: 'URL',
        enphaseUser: 'Enphase User',
        enphaseSerial: 'Enphase Serial',
        meterReadingsPerMinute: 'Abtastwerte pro Minute',
        meterType: 'Type des Messgeräts',
        noDevicesOnMonitor: 'Es wurde kein Verbraucher für das aktuelle Messgrät angelegt.',
        deviceName: 'Verbrauchername',
        deviceQuality: 'Verbraucher Qualität',
        deviceType: 'Gerätetyp',
        deviceCountLabel: 'Anzahl identischer Geräte',
        subscriptionType: 'Software-Paket',
        subscriptionUntil: 'Gültig bis',
        partner: 'Partner',
        purpose: 'Zweck',
        flavor: 'Modbus Variante',
        modbusId: 'Modbus Id',
        hub: 'Controller',
        production: 'Produktion',
        grid: 'Grid',
        usage: 'Verbrauch',
        storage: 'Speicher',
        hubDetails: 'Controller Details',
        deleteMessages: 'Meldungen löschen',
        status: 'Status',
        age: 'Alter',
        message: 'Meldung',
        switchStatus: 'Status',
        meterStatus: 'Status',
        noController: '-- keiner --',
        activateSupport: 'Aktivieren Sie den Online-Support',
        deactivateSupport: 'Online-Support deaktivieren',
        onlineSupportLabel: 'Online Support',
        onlineSupportUnknown: 'Unbekannt',
        onlineSupportActive: 'Aktiv',
        onlineSupportNotActive: 'Nicht Aktiv',
        errorAlertTitle: 'Vorsicht',
        errorAlertMessage: 'Dieses Gerät ist mit einem Schalter verbunden. Bitte löschen Sie den Schalter oder trennen Sie das Gerät, bevor Sie es löschen.',
        triggerUpdateWaPi: 'Update WA-PI',
        triggerUpdateWaSem: 'Update WA-SEM',
        triggerUpdateMeterSupport: 'Update Meter Support',
        triggerUpdateEvcc: 'Update Evcc',
        triggerReadCompleteConfig: 'Komplette Konfiguration lesen',
        triggerReboot: 'Neu starten',
        triggerRestartWaPi: 'Wa-Pi neustarten',
        triggerRestartWaSem: 'Wa-Sem neustarten',
        triggerRestartWaMeterSupport: 'Wa-Meter-Support neustarten',
        triggerInstallLogConfigs: 'Install log-configs',
        triggerInstallLog2Ram: 'Install log2ram',
        mergeModalTitle1: 'Zusammenführen von "',
        mergeModalTitle2: '" in:',
        mergeModalOk: 'Zusammenführen',

        // Users
        invitedUsers: 'Eingeladene Benutzer',
        owner: 'Besitzer',
        userName: 'Vorname',
        userSurname: 'Familienname',
        userEmail: 'Email-Adresse',
        addUser: 'Benutzer anlegen',
        sureToDeleteContent: 'Gelöschte Einladung Email: ',
        sureToDeleteHelp: 'Geben sie zur Bestätigung den Namen des Benutzers ein: ',

        modbusStateFunctionCode: "Modbus Functioncode für State",
        modbusStateRegisterStartAddress: "Modbus Register-Startadresse für State",
        modbusStateRegisterQuantity: "Modbus Register-Quantity für State",
        modbusStateMinValue: "Modbus Min-Value für State",
        modbusStateMaxValue: "Modbus Max-Value für State",
        modbusStateDataType: "Modbus Datentyp für State",
        modbusStateFactor: "Modbus Faktor (min- und max-Values werden damit multipliziert) für State",

        modbusWattFunctionCode: "Modbus Functioncode für das auslesen von Watt-Werten",
        modbusWattRegisterStartAddress: "Modbus Register-Startadresse für das auslesen von Watt-Werten",
        modbusWattRegisterQuantity: "Modbus Register-Quantity für das auslesen von Watt-Werten",
        modbusWattDataType: "Modbus Datentyp für das auslesen von Watt-Werten",
        modbusWattFactor: "Modbus Faktor für ausgelesenen Watt-Wert",

        modbusTempFunctionCode: "Modbus Functioncode für das auslesen von Temperatur-Werten",
        modbusTempRegisterStartAddress: "Modbus Register-Startadresse für das auslesen von Temperatur-Werten",
        modbusTempRegisterQuantity: "Modbus Register-Quantity für das auslesen von Temperatur-Werten",
        modbusTempDataType: "Modbus Datentyp für das auslesen von Temperatur-Werten",
        modbusTempFactor: "Modbus Faktor für ausgelesenen Temperatur-Wert",
        meterA: "Messgerät A",
        meterB: "Messgerät B",
        meterSoc: "Messgerät für SoC",
        solaxRegistrationNr: "Registration number",
        neoomBeaamApiKey: 'Schlüssel für BEAAM API',
    }
;